import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ name: 'Subtitle' })
export default class default_1 extends Vue {
    @Prop()
    event;
    get subtitle() {
        return this.event?.subtitle;
    }
}
